import { useEffect } from 'react';

import { CheckoutStepPayload, EventType, dispatch } from '../events';
import { useCheckoutSummary } from '../CheckoutSummaryProvider';
import { useEvent } from '../../Common/EventProvider';

const useCheckoutStepTracking = (step: string) => {
  const { event } = useEvent();
  const { checkoutSummary } = useCheckoutSummary();

  useEffect(() => {
    dispatch(EventType.CheckoutStep, {
      project: {
        id: event.project.id,
        currency: event.project.currency,
      },
      event: {
        id: event.id,
        title: event.title,
      },
      step,
      cart: {
        amount: checkoutSummary?.amount ?? 0,
        vat_amount: checkoutSummary?.vat_amount ?? 0,
        coupon: checkoutSummary?.coupon_code?.value ?? null,
      },
      tickets: (checkoutSummary?.tickets ?? []).map((item) => ({
        id: item.purchase.ticket.id,
        title: item.purchase.ticket.title,
        amount: item.purchase.amount,
        quantity: item.quantity,
        time_slot: (item.purchase.time_slot
          && `${item.purchase.time_slot.start_date} ${item.purchase.time_slot.start_time}`
        ) || null,
      })),
      products: (checkoutSummary?.products ?? []).map((item) => ({
        id: item.purchase.product.id,
        title: item.purchase.product.title,
        amount: item.purchase.amount,
        quantity: item.quantity,
        product_variant: (item.purchase.product_variant && item.purchase.product_variant.title) || null,
      })),
    } as CheckoutStepPayload);
  }, [event, step, checkoutSummary]);
};

export default useCheckoutStepTracking;
